import { DEFAULT_CURRENCY } from '#/constants/audd';

export enum EUrlParams {
  PaymentRouteId = 'paymentRouteId',
  StoredDataKey = 'storedDataKey',
  Theme = 'theme',
  Lang = 'lang',
  CurrencyId = 'currencyId',
  ApiUrl = 'apiUrl',
  WalletId = 'walletId',
  Flow = 'flow',
  Address = 'address',
  AddressTag = 'addressTag',
  Network = 'network',
}

export interface IUrlParams {
  /**
   * The route cointrader opened the widget from. Kept because the host still sends it, but the
   * widget resolves its own routes from `currencyId` — one per network plus the fiat leg — so this
   * no longer decides which route anything is submitted or priced against.
   */
  paymentRouteId: string;
  storedDataKey: string;
  theme: string;
  lang: string;
  currencyId: string;
  apiUrl: string;
  walletId: string;
  flow: string;
  /**
   * A saved crypto address the withdrawal form opens with, sent when the host starts a withdrawal
   * from its address book. `network` is the network that address was saved for.
   */
  address: string;
  addressTag: string;
  network: string;
}

export const getUrlParams = (): IUrlParams => {
  const params = new URLSearchParams(window.location.search);
  return {
    paymentRouteId: params.get(EUrlParams.PaymentRouteId) || '',
    storedDataKey: params.get(EUrlParams.StoredDataKey) || '',
    theme: params.get(EUrlParams.Theme) || 'dark',
    lang: params.get(EUrlParams.Lang) || 'en',
    currencyId: params.get(EUrlParams.CurrencyId) || DEFAULT_CURRENCY,
    apiUrl: params.get(EUrlParams.ApiUrl) || '',
    walletId: params.get(EUrlParams.WalletId) || '',
    flow: params.get(EUrlParams.Flow) || '',
    address: params.get(EUrlParams.Address) || '',
    addressTag: params.get(EUrlParams.AddressTag) || '',
    network: params.get(EUrlParams.Network) || '',
  };
};
